export default __webpack_public_path__ + "static/media/anchor.2133f1f6.png";